module.exports = __webpack_public_path__ + "img/resized-APP-0019-2.d1602804.png";